import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import ErrorHandler from '../../common/error/components/error-handler';
import FiltersSidepanel from '../../common/filters/filters-sidepanel';
import { viewConfig } from '../../common/gantt/config';
import { openPlanningAndView } from '../../common/gantt/containers/gantt-actions';
import { additionalTabTypes, blockTypes } from '../../utils/app-configs';
import WorkGridWrapper from '../../workgrid/components/work-grid-wrapper';
import WorklistWrapper from '../../worklist/components/worklist-wrapper';
import CreateView from '../../worklist/containers/create-view-container';
import ManageViews from '../../worklist/containers/manage-views-container';

const PlanningBoardBottom = ({
  isDataLoading,
  filterDefinitions,
  updateFilters,
  updateView,
  activeFilters,
  handleOrderClick,
  setSelectedOrderIds,
  split,
  menuVisible,
  fullScreen,
  match,
  views,
  addedBlockIds,
  filterGroups,
  intl,
  clearWorklistData,
  relativeTimingRangeOptions,
  error,
  history,
}) => {
  const filterRef = useRef();
  const dispatch = useDispatch();

  const handlePlanningRedirect = (params) => {
    dispatch(openPlanningAndView({
      id: params.id,
      type: blockTypes.planning,
      viewId: 'currentView',
      history,
      boardId: viewConfig.boardIdTypes.service,
      intl,
      filters: match.params.filters,
    }),
    );
  };

  const handleRowClick = (item) => {
    if (item.uri) {
      window.open(
        `${window.location.origin}/${item.uri}/dashboard`, '_blank',
      );
    }
  };

  return (
    <>
      <ErrorHandler type='notification' error={error} />
      <WorklistWrapper isPlanningboard={true}>
        <Routes>
          <Route
            path={'filterselect'}
            element={
              <FiltersSidepanel
                filters={match.params.filters || ''}
                sort={match.params.sort || ''}
                worklistId={match.params.worklistId}
                filterRef={filterRef}
                isDataLoading={isDataLoading}
                filterDefinitions={filterDefinitions}
                updateFilters={updateFilters}
                activeFilters={activeFilters}
                isPlanningBoard={true}
                filterGroups={filterGroups}
                relativeTimingRangeOptions={relativeTimingRangeOptions}
                additionalTabs={[additionalTabTypes.columns]}
              />
            }
          />
          <Route
            path={'create-view'}
            element={
              <CreateView
                id={match.params.worklistId}
                filters={match.params.filters || ''}
                sort={match.params.sort || ''}
                updateView={updateView}
                views={views}
                isPlanningBoard={true}
                expandOption={true}
              />
            }
          />
          <Route
            path={'manage-views'}
            element={<ManageViews
              id={match.params.worklistId}
              isPlanningBoard={true}
              expandOption={true}
            />}
          />
        </Routes>
        <Outlet />
        <WorkGridWrapper
          menuVisible={menuVisible}
          filterWidth={filterRef?.current?.clientWidth}
          isPlanningBoard={true}
          fullScreen={fullScreen}
          split={split}
          handleOrderClick={handleOrderClick}
          addedBlockIds={addedBlockIds}
          setSelectedOrderIds={setSelectedOrderIds}
          clearWorklistData={clearWorklistData}
          selectable={true}
          hasIconsColumn={true}
          rowDragMultiRow={true}
          sizeToFit={true}
          draggable={true}
          masterDetail={true}
          worklistId='serviceplanning'
          columnActions={{
            Date: handlePlanningRedirect,
            Description: handleRowClick,
          }}
        />
      </WorklistWrapper>
    </>
  );
};

PlanningBoardBottom.propTypes = {
  isDataLoading: PropTypes.bool,
  filterDefinitions: PropTypes.array,
  updateFilters: PropTypes.func,
  updateView: PropTypes.func,
  activeFilters: PropTypes.object,
  handleOrderClick: PropTypes.func,
  setSelectedOrderIds: PropTypes.func,
  split: PropTypes.bool,
  menuVisible: PropTypes.bool,
  match: PropTypes.object.isRequired,
  views: PropTypes.array,
  fullScreen: PropTypes.bool,
  addedBlockIds: PropTypes.string,
  filterGroups: PropTypes.filterGroups,
  clearWorklistData: PropTypes.func,
  intl: PropTypes.object,
  relativeTimingRangeOptions: PropTypes.object,
  error: PropTypes.object,
  history: PropTypes.object,
};

export default injectIntl(withRouter(PlanningBoardBottom));
